export default __webpack_public_path__ + "static/media/H4006.2.3517ef29.mp3";